import toast from 'react-hot-toast';
import { useFormat } from 'helpers/hooks/useFormat';

const useFeedbackToasts = () => {
  const { formatMessage: formatErrorMessage } = useFormat({ name: 'error' });
  const { formatMessage: formatAccountMessage } = useFormat({ name: 'account' });

  const notifyDataUpdated = () =>
    toast.success(formatAccountMessage({ id: 'data.updated', defaultMessage: 'Data updated successfully.' }));

  const notifyWentWrong = () =>
    toast.error(formatErrorMessage({ id: 'wentWrong', defaultMessage: 'Sorry, something went wrong..' }));

  const notifyCustomMsg = (type: string, msg: string) => (type == 'success' ? toast.success(msg) : toast.error(msg));

  return { notifyDataUpdated, notifyWentWrong, notifyCustomMsg };
};

export default useFeedbackToasts;
